/**
 *
 * ComplimentTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import { CheckCircleIcon } from 'assets/v2/icons';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.greenDark};
    background: ${COLORS.greenLight};
    border-color: ${COLORS.green};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.green};
    }
  }
`;

function ComplimentTag(props) {
  return <StyledTag label="Compliment" icon={<CheckCircleIcon />} {...props} />;
}

export default memo(ComplimentTag);
